import { createTypes } from "@/store/utils";

export const FETCH_CSV_HISTORY = createTypes("FETCH_CSV_HISTORY");
